module.exports = __webpack_public_path__ + "media/images/lokshina-2e15239c84b426f82f956011d5919dba.png";